module.exports = __webpack_public_path__ + "media/images/lb/373-cc571fdbca9b8d7353f22330cc3d6c72.svg";